export interface Part {
  id: string;
  name: string;
  sku: string;
  category: string;
  categorySlug: string;
  price: number;
  originalPrice?: number;
  rating: number;
  reviewCount: number;
  badge?: string;
  image: string;
  inStock: boolean;
  description: string;
}

export const featuredParts: Part[] = [
  {
    id: 'bp001',
    name: 'Vertical Blind Vane Carrier Stem',
    sku: 'VB-STEM-01',
    category: 'Vertical Blind Parts',
    categorySlug: 'vertical-blind-parts',
    price: 3.49,
    rating: 4.8,
    reviewCount: 412,
    badge: 'Best Seller',
    inStock: true,
    description: 'Universal replacement carrier stem for vertical blinds. Fits most standard track systems.',
    image: 'https://public.readdy.ai/ai/img_res/45a20e39b34c35958f9b9115eb800f28.jpg',
  },
  {
    id: 'bp002',
    name: 'Mini Blind Lift Cord 18 ft',
    sku: 'MB-CORD-18',
    category: 'Mini Blind Parts',
    categorySlug: 'mini-blind-parts',
    price: 5.99,
    originalPrice: 8.49,
    rating: 4.9,
    reviewCount: 638,
    badge: 'Top Seller',
    inStock: true,
    description: 'Heavy-duty replacement lift cord for horizontal mini blinds. 18 ft length, braided polyester.',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20product%20photo%20of%20white%20braided%20polyester%20window%20blind%20lift%20cord%20neatly%20coiled%20on%20clean%20white%20background%2C%20sharp%20e-commerce%20photography%2C%20simple%20isolated%20product%20shot%2C%20rope%20texture%20visible&width=600&height=600&seq=part_cord_002&orientation=squarish',
  },
  {
    id: 'bp003',
    name: 'Inside Mount Bracket Set (Pair)',
    sku: 'HW-IMB-PAIR',
    category: 'Mounting Brackets',
    categorySlug: 'mounting-brackets',
    price: 7.99,
    originalPrice: 11.99,
    rating: 4.7,
    reviewCount: 287,
    badge: 'Popular',
    inStock: true,
    description: 'Steel inside mount brackets for standard horizontal blinds. Universal fit, set of 2.',
    image: 'https://readdy.ai/api/search-image?query=macro%20product%20photography%20of%20two%20metal%20steel%20window%20blind%20mounting%20brackets%20on%20white%20background%2C%20silver%20metallic%20hardware%2C%20clean%20e-commerce%20style%2C%20sharp%20detail%2C%20isolated&width=600&height=600&seq=part_bracket_003&orientation=squarish',
  },
  {
    id: 'bp004',
    name: 'Vertical Blind Replacement Slats 82"',
    sku: 'VB-SLAT-82',
    category: 'Vertical Blind Parts',
    categorySlug: 'vertical-blind-parts',
    price: 2.25,
    rating: 4.6,
    reviewCount: 524,
    badge: 'Fast Ship',
    inStock: true,
    description: 'Standard white vinyl vertical blind replacement vane slat, 82 inch. Sold individually.',
    image: 'https://readdy.ai/api/search-image?query=product%20flat%20lay%20of%20white%20vinyl%20vertical%20blind%20slat%20vane%20replacement%20part%20on%20neutral%20gray%20background%2C%20clean%20minimal%20e-commerce%20product%20photo%2C%20window%20treatment%20hardware%20component%2C%20sharp&width=600&height=600&seq=part_slat_004&orientation=squarish',
  },
  {
    id: 'bp005',
    name: 'Drapery Traverse Rod Carrier',
    sku: 'DH-CARRIER-01',
    category: 'Drapery Hardware',
    categorySlug: 'drapery-hardware',
    price: 4.79,
    originalPrice: 6.99,
    rating: 4.8,
    reviewCount: 193,
    badge: 'In Stock',
    inStock: true,
    description: 'Two-way draw traverse rod master carrier. Compatible with most standard traverse rod systems.',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20product%20photo%20of%20white%20plastic%20drapery%20traverse%20rod%20carrier%20master%20slide%20component%20on%20white%20background%2C%20clean%20isolated%20product%20photography%2C%20window%20hardware%20part%2C%20sharp%20detail&width=600&height=600&seq=part_carrier_005&orientation=squarish',
  },
  {
    id: 'bp006',
    name: 'Blind Tilt Wand 28" Clear',
    sku: 'MB-WAND-28C',
    category: 'Mini Blind Parts',
    categorySlug: 'mini-blind-parts',
    price: 3.25,
    rating: 4.7,
    reviewCount: 341,
    badge: 'Universal',
    inStock: true,
    description: 'Clear acrylic tilt wand for horizontal blinds. 28 inch length, snap-on hook included.',
    image: 'https://readdy.ai/api/search-image?query=product%20photo%20of%20clear%20transparent%20acrylic%20blind%20tilt%20wand%20control%20stick%20on%20white%20background%2C%20isolated%20e-commerce%20photo%2C%20window%20blind%20accessories%2C%20sharp%20clean%20lighting&width=600&height=600&seq=part_wand_006&orientation=squarish',
  },
  {
    id: 'bp007',
    name: 'Chain Bead Loop 48" White',
    sku: 'CH-BEADLOOP-48',
    category: 'Chains & Cords',
    categorySlug: 'chains-cords',
    price: 4.49,
    originalPrice: 6.49,
    rating: 4.9,
    reviewCount: 476,
    badge: 'Best Value',
    inStock: true,
    description: 'Replacement bead chain loop for roller shades and cellular shades. 4.5mm diameter beads.',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20product%20photo%20of%20white%20plastic%20bead%20chain%20loop%20for%20roller%20shade%20control%20coiled%20on%20white%20background%2C%20clean%20e-commerce%20product%20shot%2C%20window%20treatment%20component%2C%20sharp%20macro%20photography&width=600&height=600&seq=part_chain_007&orientation=squarish',
  },
  {
    id: 'bp008',
    name: 'Valance Clip Set — Pack of 4',
    sku: 'VC-CLIP-4PK',
    category: 'Valance Clips',
    categorySlug: 'valance-clips',
    price: 5.49,
    rating: 4.6,
    reviewCount: 158,
    badge: 'Multi-Pack',
    inStock: true,
    description: 'Plastic valance clips for horizontal blinds. Pack of 4. Snaps onto front rail for clean finish.',
    image: 'https://readdy.ai/api/search-image?query=product%20photography%20of%20four%20white%20plastic%20window%20blind%20valance%20mounting%20clips%20in%20a%20row%20on%20white%20background%2C%20clean%20e-commerce%20style%2C%20window%20hardware%20components%2C%20sharp%20isolated%20macro%20shot&width=600&height=600&seq=part_valclip_008&orientation=squarish',
  },
  {
    id: 'bp009',
    name: 'Horizontal Blind Headrail End Cap Set',
    sku: 'HB-ENDCAP-02',
    category: 'Horizontal Blind Parts',
    categorySlug: 'horizontal-blind-parts',
    price: 3.99,
    originalPrice: 5.49,
    rating: 4.7,
    reviewCount: 203,
    badge: 'Popular',
    inStock: true,
    description: 'Replacement end caps for horizontal blind headrails. Left and right pair. Fits 1-inch and 2-inch headrails.',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20macro%20product%20photo%20of%20white%20plastic%20horizontal%20blind%20headrail%20end%20cap%20replacement%20parts%20pair%20on%20white%20background%2C%20clean%20isolated%20e-commerce%20product%20shot%2C%20window%20blind%20hardware%20detail%20sharp&width=600&height=600&seq=part_endcap_009&orientation=squarish',
  },
  {
    id: 'bp010',
    name: 'Horizontal Blind Cord Lock',
    sku: 'HB-CORDLOCK-01',
    category: 'Horizontal Blind Parts',
    categorySlug: 'horizontal-blind-parts',
    price: 4.25,
    rating: 4.8,
    reviewCount: 317,
    badge: 'Best Seller',
    inStock: true,
    description: 'Universal cord lock for 1-inch and 2-inch horizontal blinds. Locks lift cord at any height.',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20product%20photo%20of%20white%20plastic%20window%20blind%20cord%20lock%20mechanism%20on%20white%20background%2C%20clean%20e-commerce%20product%20photography%2C%20blind%20repair%20hardware%20component%2C%20isolated%20sharp%20detail&width=600&height=600&seq=part_cordlock_010&orientation=squarish',
  },
  {
    id: 'bp011',
    name: 'Valance Return Clip — Pair',
    sku: 'VC-RETURN-02',
    category: 'Valance Clips',
    categorySlug: 'valance-clips',
    price: 2.99,
    rating: 4.5,
    reviewCount: 94,
    badge: 'Value',
    inStock: true,
    description: 'Side return clips for valance panels. Holds valance ends flush to wall for a finished look.',
    image: 'https://readdy.ai/api/search-image?query=product%20photography%20of%20small%20white%20plastic%20valance%20return%20side%20clips%20pair%20on%20white%20background%2C%20isolated%20e-commerce%20style%2C%20window%20blind%20valance%20hardware%2C%20sharp%20clean%20macro%20photo&width=600&height=600&seq=part_valreturn_011&orientation=squarish',
  },
  {
    id: 'bp012',
    name: 'Outside Mount Bracket Pair',
    sku: 'MB-OMB-PAIR',
    category: 'Mounting Brackets',
    categorySlug: 'mounting-brackets',
    price: 8.99,
    originalPrice: 12.99,
    rating: 4.8,
    reviewCount: 245,
    badge: 'Top Rated',
    inStock: true,
    description: 'Heavy-duty outside mount brackets for wall or ceiling installation. Fits 1-inch and 2-inch headrails.',
    image: 'https://readdy.ai/api/search-image?query=macro%20photo%20of%20two%20heavy%20duty%20metal%20outside%20mount%20window%20blind%20wall%20mounting%20brackets%20on%20white%20background%2C%20silver%20steel%20hardware%2C%20e-commerce%20product%20photography%20clean%20isolated%20sharp&width=600&height=600&seq=part_omb_012&orientation=squarish',
  },
];

export interface PartCategory {
  id: string;
  name: string;
  description: string;
  partCount: string;
  slug: string;
  icon: string;
  image: string;
  color: string;
}

export const partCategories: PartCategory[] = [
  {
    id: 'cat1',
    name: 'Vertical Blind Parts',
    description: 'Carriers, stems, vanes, weights & tracks',
    partCount: '200+',
    slug: '/category/vertical-blind-parts',
    icon: 'ri-layout-column-line',
    color: 'amber',
    image: 'https://readdy.ai/api/search-image?query=flat%20lay%20product%20photography%20of%20vertical%20blind%20replacement%20parts%20components%20spread%20out%20on%20white%20background%20including%20carriers%20slats%20stems%20white%20plastic%20hardware%20e-commerce%20style%20sharp%20clean&width=400&height=300&seq=cat_vbparts_v2&orientation=landscape',
  },
  {
    id: 'cat2',
    name: 'Horizontal Blind Parts',
    description: 'Headrails, end caps, cord locks, slats',
    partCount: '180+',
    slug: '/category/horizontal-blind-parts',
    icon: 'ri-menu-line',
    color: 'stone',
    image: 'https://readdy.ai/api/search-image?query=organized%20flat%20lay%20of%20horizontal%20blind%20headrail%20parts%20end%20caps%20cord%20locks%20and%20slat%20components%20on%20white%20background%20e-commerce%20product%20photography%20sharp%20clean%20detail%20window%20hardware%20neutral%20tones&width=400&height=300&seq=cat_hbparts_v2&orientation=landscape',
  },
  {
    id: 'cat3',
    name: 'Mini Blind Parts',
    description: 'Lift cords, wands, ladders, tilt mechanisms',
    partCount: '350+',
    slug: '/category/mini-blind-parts',
    icon: 'ri-line-height',
    color: 'amber',
    image: 'https://readdy.ai/api/search-image?query=organized%20flat%20lay%20of%20mini%20blind%20replacement%20parts%20on%20white%20background%20including%20lift%20cords%20tassels%20wands%20plastic%20components%20window%20hardware%20product%20photography%20sharp%20clean%20minimal&width=400&height=300&seq=cat_mbparts_v2&orientation=landscape',
  },
  {
    id: 'cat4',
    name: 'Valance Clips',
    description: 'Snap clips, return clips, hold-down pins',
    partCount: '60+',
    slug: '/category/valance-clips',
    icon: 'ri-price-tag-3-line',
    color: 'stone',
    image: 'https://readdy.ai/api/search-image?query=flat%20lay%20macro%20photography%20of%20assorted%20plastic%20window%20blind%20valance%20clip%20types%20snap%20clips%20return%20clips%20organized%20on%20white%20background%20clean%20isolated%20e-commerce%20product%20shot%20minimal%20sharp&width=400&height=300&seq=cat_valclips_v2&orientation=landscape',
  },
  {
    id: 'cat5',
    name: 'Mounting Brackets',
    description: 'Inside mount, outside mount & ceiling brackets',
    partCount: '120+',
    slug: '/category/mounting-brackets',
    icon: 'ri-tools-line',
    color: 'amber',
    image: 'https://readdy.ai/api/search-image?query=assortment%20of%20metal%20and%20plastic%20window%20blind%20mounting%20brackets%20inside%20outside%20mount%20types%20arranged%20on%20white%20background%20flat%20lay%20product%20photography%20e-commerce%20style%20isolated%20sharp%20neutral&width=400&height=300&seq=cat_mbrack_v2&orientation=landscape',
  },
  {
    id: 'cat6',
    name: 'Chains & Cords',
    description: 'Bead chains, pull cords, safety devices',
    partCount: '120+',
    slug: '/category/chains-cords',
    icon: 'ri-link-line',
    color: 'stone',
    image: 'https://readdy.ai/api/search-image?query=organized%20collection%20of%20window%20shade%20chains%20bead%20loops%20pull%20cords%20and%20safety%20brackets%20on%20white%20background%20clean%20product%20flat%20lay%20e-commerce%20photography%20sharp%20minimal%20isolated&width=400&height=300&seq=cat_chains_v2&orientation=landscape',
  },
  {
    id: 'cat7',
    name: 'Drapery Hardware',
    description: 'Traverse rods, rings, carriers & hooks',
    partCount: '150+',
    slug: '/category/drapery-hardware',
    icon: 'ri-drop-line',
    color: 'amber',
    image: 'https://readdy.ai/api/search-image?query=flat%20lay%20of%20curtain%20drapery%20hardware%20components%20traverse%20rod%20parts%20rings%20hooks%20carriers%20on%20white%20background%20clean%20isolated%20e-commerce%20product%20photography%20sharp%20minimal&width=400&height=300&seq=cat_draphw_v2&orientation=landscape',
  },
];
